import "entry/common"
import addCSRFTokenToAjaxRequests from "lib/csrfAjaxPrefilter"
import "react_mount_public"
import "react_mount_application"
import "stimulus_application"

// Some forms on these pages, like author registration, send jQuery writes
// for readers with no session, so they need the token up front.
addCSRFTokenToAjaxRequests()

// Workaround a font issue on Chrome/Windows.
import "lib/chrome_fonts"

// these are being called from inside ERB views, so it needs global scope for now
window.TC.BasePage = require("pages/base_page").default
window.TC.ChooserView = require("views/chooser_view").default
window.TC.NewRegistrationPage = require("pages/new_registration_page").default
window.TC.ProfileCredentialsPage = require("pages/profile_credentials_page").default
window.TC.SearchPage = require("pages/search_page").default
